import { render, staticRenderFns } from "./datadownload.vue?vue&type=template&id=3728f4db&scoped=true&"
import script from "./datadownload.vue?vue&type=script&lang=js&"
export * from "./datadownload.vue?vue&type=script&lang=js&"
import style0 from "./datadownload.vue?vue&type=style&index=0&id=3728f4db&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3728f4db",
  null
  
)

component.options.__file = "datadownload.vue"
export default component.exports